export default {
    Commitment: {
        title: "评分承诺书",
        desc: "请在下方灰色区域中进行签名",
        reset: "重签",
        confirm: "确定",
    },
    Interviewer: {
        signIn: "考官签到",
        photoSignIn: "拍照签到",
        complete: "完成签到",
        rePhoto: "重新拍照",
        capture: "拍照",
        cancel: "取消",
        confirmUpload: "确认签到",
    },
    ResultTable: {
        average: "平均分",
        max: "最高分",
        min: "最低分",
        sequence: "序号",
        name: "姓名",
        gender: "性别",
        score: "得分",
        interviewing: "进行中",
    },
    ScoreTab: {
        score: "分",
        half: "半分",
        all: "满分",
        already: "已评",
        comment: "评语",
    },
    StuViewer: {
        signIn: "候选人签到",
        photoSignIn: "拍照签到",
        upload: "上传文件",
        success: "身份核验通过。",
        fail: "身份核验未通过!",
        confirm: "确定",
        complete: "完成签到",
        rePhoto: "重新拍照",
    },
};
